import type { Perfil } from '@/types'

export const mockMembros: Perfil[] = [
  {
    id: '1',
    user_id: '123e4567-e89b-12d3-a456-426614174000',
    nome_exibicao: 'João Silva',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Joao',
    telefone: '(11) 98765-4321',
    papel: 'comum',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    created_at: '2024-01-15T10:00:00Z',
    updated_at: '2024-01-15T10:00:00Z',
  },
  {
    id: '2',
    user_id: '123e4567-e89b-12d3-a456-426614174010',
    nome_exibicao: 'Maria Santos',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Maria',
    telefone: '(11) 98765-4322',
    papel: 'gestor',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    created_at: '2024-01-10T10:00:00Z',
    updated_at: '2024-01-10T10:00:00Z',
  },
  {
    id: '3',
    user_id: '123e4567-e89b-12d3-a456-426614174011',
    nome_exibicao: 'Pedro Oliveira',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Pedro',
    telefone: '(11) 98765-4323',
    papel: 'admin',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    created_at: '2024-01-05T10:00:00Z',
    updated_at: '2024-01-05T10:00:00Z',
  },
  {
    id: '4',
    user_id: '123e4567-e89b-12d3-a456-426614174012',
    nome_exibicao: 'Ana Costa',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Ana',
    telefone: '(11) 98765-4324',
    papel: 'comum',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    created_at: '2024-02-01T10:00:00Z',
    updated_at: '2024-02-01T10:00:00Z',
  },
  {
    id: '5',
    user_id: '123e4567-e89b-12d3-a456-426614174013',
    nome_exibicao: 'Carlos Mendes',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Carlos',
    telefone: '(11) 98765-4325',
    papel: 'comum',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    created_at: '2024-02-05T10:00:00Z',
    updated_at: '2024-02-05T10:00:00Z',
  },
  {
    id: '6',
    user_id: '123e4567-e89b-12d3-a456-426614174014',
    nome_exibicao: 'Juliana Lima',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Juliana',
    telefone: '(11) 98765-4326',
    papel: 'gestor',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    created_at: '2024-02-10T10:00:00Z',
    updated_at: '2024-02-10T10:00:00Z',
  },
  {
    id: '7',
    user_id: '123e4567-e89b-12d3-a456-426614174015',
    nome_exibicao: 'Fernando Rocha',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Fernando',
    telefone: '(11) 98765-4327',
    papel: 'comum',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    created_at: '2024-02-15T10:00:00Z',
    updated_at: '2024-02-15T10:00:00Z',
  },
  {
    id: '8',
    user_id: '123e4567-e89b-12d3-a456-426614174016',
    nome_exibicao: 'Beatriz Souza',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Beatriz',
    telefone: '(11) 98765-4328',
    papel: 'comum',
    igreja_id: '123e4567-e89b-12d3-a456-426614174002',
    created_at: '2024-03-01T10:00:00Z',
    updated_at: '2024-03-01T10:00:00Z',
  },
]

export const mockMembrosPorPapel = {
  comum: mockMembros.filter((m) => m.papel === 'comum'),
  gestor: mockMembros.filter((m) => m.papel === 'gestor'),
  admin: mockMembros.filter((m) => m.papel === 'admin'),
  financeiro: mockMembros.filter((m) => m.papel === 'financeiro'),
}
